import React from 'react';
import PropTypes from 'prop-types';
import {
  ByocProgressBarContainer,
  ByocProgressStep,
  ByocProgressLine,
  ByocProgressStepCircle,
  ByocProgressStepLabel
} from 'components/ByocProgressBar/styles';

const ByocProgressBar = ({currentStep = 1, steps = []}) => {
  return (
    <ByocProgressBarContainer>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;
        const isPending = stepNumber > currentStep;
        // Line should be red if the previous step is completed
        const isLineCompleted = stepNumber < currentStep;

        return (
          <React.Fragment key={step.id || index}>
            <ByocProgressStep>
              <ByocProgressStepCircle
                $isCompleted={isCompleted}
                $isActive={isActive}
                $isPending={isPending}
              >
                {isCompleted ? (
                  <svg
                    width='12'
                    height='9'
                    viewBox='0 0 12 9'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M1 4.5L4.5 8L11 1'
                      stroke='white'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                ) : (
                  <span>{stepNumber}</span>
                )}
              </ByocProgressStepCircle>
              <ByocProgressStepLabel
                $isCompleted={isCompleted}
                $isActive={isActive}
                $isPending={isPending}
              >
                {step.label}
              </ByocProgressStepLabel>
            </ByocProgressStep>
            {index < steps.length - 1 && (
              <ByocProgressLine
                $isCompleted={isLineCompleted}
                $isActive={isActive}
                $isPending={isPending}
              />
            )}
          </React.Fragment>
        );
      })}
    </ByocProgressBarContainer>
  );
};

ByocProgressBar.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired
    })
  ).isRequired
};

ByocProgressBar.defaultProps = {
  currentStep: 1
};

export default ByocProgressBar;
